import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const PaymentTab = ({ shop, onAddPayment, onViewPayment, onDeletePayment }) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h4 className="font-semibold text-lg">SAAS Payments</h4>
        <Button size="sm" onClick={onAddPayment}>
          <FontAwesomeIcon icon={faPlus} className="mr-2" /> Add Payment
        </Button>
      </div>
      <Card className="p-8 border border-gray-200 text-center">
        <h4 className="text-lg font-semibold mb-2">Payment Records</h4>
        <p className="text-gray-600">
          Payment management features coming soon...
        </p>
        <p className="text-sm text-gray-600 mt-2">
          Total payments: {shop.saasPayments?.length || 0}
        </p>
      </Card>
    </div>
  );
};

export default PaymentTab;
